"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoRooms/RoomBody.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);




var _videoRoom = require('web/selectors/videoRoom');
var _hooks = require('web/services/hooks');

var _Room = require('web/components/VideoRooms/Room'); var _Room2 = _interopRequireDefault(_Room);









// The selector builds new lists on every call; keep the previous ones while
// their items are unchanged.
const areAdminsListsEqual = (a, b) =>
  a.UserAdmins.length === b.UserAdmins.length &&
  a.UserAdmins.every((u, i) => u === b.UserAdmins[i]) &&
  a.TeamAdminKeys.length === b.TeamAdminKeys.length &&
  a.TeamAdminKeys.every((k, i) => k === b.TeamAdminKeys[i])

// memo keeps the PureComponent / connect() bailout on unchanged props.
const RoomBody = _react.memo.call(void 0, function RoomBody ({
  roomKey, onRoomShare, onRoomLinkCopy,
}) {
  const roomLink = _hooks.useAppSelector.call(void 0, state => _videoRoom.selectVideoRoomLink.call(void 0, state, roomKey))
  const isRoomLoaded = _hooks.useAppSelector.call(void 0, state => !!_videoRoom.selectVideoRoomByKey.call(void 0, state, roomKey))
  const roomAdminsLists = _hooks.useAppSelector.call(void 0, 
    state => _videoRoom.selectVideoRoomAdminsLists.call(void 0, state, roomKey),
    areAdminsListsEqual,
  )

  const handleRemoveAdmin = _react.useCallback.call(void 0, (adminKey) => {
    const isAdminATeam = roomAdminsLists.TeamAdminKeys.includes(adminKey)
    if (isAdminATeam) { return _actions2.default.removeVideoRoomAdminTeam({ RoomKey: roomKey, TeamKey: adminKey }) }
    return _actions2.default.removeVideoRoomAdminUser({ RoomKey: roomKey, UserKey: adminKey })
  }, [roomKey, roomAdminsLists])

  if (!isRoomLoaded) return null

  return (
    // The JS also mapped and passed currentUserKey and isRoomPrivate
    // (RequireGuestApproval), which Room never read.
    _react2.default.createElement(_Room2.default, {
      roomAdminsLists: roomAdminsLists,
      onRemoveAdmin: handleRemoveAdmin,
      roomKey: roomKey,
      roomLink: roomLink,
      onRoomShare: onRoomShare,
      onRoomLinkCopy: onRoomLinkCopy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
    )
  )
})

exports. default = RoomBody
